declare var require: any

import { Injectable } from '@angular/core';


@Injectable()
export class SpacesService {
  
  public greenspaces;
  constructor() {
    this.greenspaces = require('../../data/greenspaces.json');
   }

  getSpaces() {
    return this.greenspaces;
  }

  getSpace(id) {
    try {
      return require(`../../data/${id}.json`);
    } catch (error) {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/spaces.service.ts